import FormularyListPageState from "@GeriMed/Store/Pages/FormularyList/FormularyListState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";

const initialState: FormularyListPageState = {
    getFormularyListParameter: {
        customerNumber: "",
    }
};
const reducer = {};

const formularyListPageReducer = createTypedReducerWithImmer(initialState,reducer);

(reducers as any).formularyListPageState = formularyListPageReducer;
